exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1F9e4ZOxXkDpO9ibUGtnUf{display:none}._2GDZ2crm11hDPa_Z8VQWXq{width:100%;height:calc(100% - 80px)}._3-stLdzAO4B5bY_aVGKwva{height:calc(100% - 70px)}._3Cf53D1l_DeHGkW5Px40TN{display:block;top:0;width:100%;height:100%;-webkit-box-sizing:border-box;box-sizing:border-box}._3Cf53D1l_DeHGkW5Px40TN iframe{max-height:100%}._17v0UMgTfHSzzidXi9Y6BW{display:none}", ""]);
// Exports
exports.locals = {
	"divContainer": "_1F9e4ZOxXkDpO9ibUGtnUf",
	"extensionContainer": "_2GDZ2crm11hDPa_Z8VQWXq",
	"extensionContainerCalendar": "_3-stLdzAO4B5bY_aVGKwva",
	"extensionHost": "_3Cf53D1l_DeHGkW5Px40TN",
	"hide": "_17v0UMgTfHSzzidXi9Y6BW"
};